/**
 * TOP ヒーロー背景画像のフェード切り替え
 * ルート: `[data-js-hero-bg]`、レイヤー: `[data-js-hero-bg-layer]`
 */
const INTERVAL_MS = 5000;
const LAYER_ACTIVE = 'p-top-hero__bg-layer--active';

export default class HeroBgFade {
  init() {
    const root = document.querySelector('[data-js-hero-bg]');
    if (!root) {
      return;
    }

    const layers = Array.from(root.querySelectorAll('[data-js-hero-bg-layer]'));
    if (layers.length < 2) {
      return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      layers.forEach((el, i) => {
        el.classList.toggle(LAYER_ACTIVE, i === 0);
      });
      return;
    }

    let index = layers.findIndex((el) => el.classList.contains(LAYER_ACTIVE));
    if (index < 0) {
      index = 0;
    }

    const tick = () => {
      const next = (index + 1) % layers.length;
      layers[index].classList.remove(LAYER_ACTIVE);
      layers[next].classList.add(LAYER_ACTIVE);
      index = next;
    };

    let timerId = window.setInterval(tick, INTERVAL_MS);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        window.clearInterval(timerId);
        timerId = null;
      } else if (!timerId) {
        timerId = window.setInterval(tick, INTERVAL_MS);
      }
    });
  }
}
